import { DatePicker } from "rsuite";
import "rsuite/dist/rsuite.min.css";
import "../css/rsuit_datetimepicker_custom-1.0.0.css";

const DateInput = (props) => {
  
  const re = new RegExp("^\\d\\d\\/\\d\\d\\/\\d\\d\\d\\d");
  if (re.test(props.value)) {

    props.value = new Date(props.value);

  }
  
  function defaultOnFocus(e) {

    if (props.onFocus !== undefined || props.onFocus !== null) {
      props.onFocus(true);
      //return true;
    }
  }

  // Default onChange function for when onChange not passed as an argument to the component.
  // NOTE: You may have to override this function when using Formik validation.
  function defaultOnChange(date) {
    if (props.onChange === undefined || props.onChange === null) {

    } else {
      props.onChange(date);
    }
  }

  return (
    <div className="date-time-picker__container" key={props.value}>
      <label
        className={`date-time-picker__label  ${
          props.hasError ? "date-time-picker__label--error" : ""
        }`}
      >
        {props.label}
        <span
          className={`date-time-picker__required  ${
            props.isRequired
              ? "date-time-picker__required--show"
              : "date-time-picker__required--hide"
          }`}
        >
          *
        </span>
      </label>
      <div className="date-time-picker__div">
        <DatePicker
          placeholder="mm/dd/yyyy"
          format="MM/dd/yyyy"
          showMeridian
          ranges={[
            {
              label: "Today",
              value: new Date()
            },
            {
              label: "yesterday",
              value: (date) => {
                const today = new Date();
                const yesterday = new Date(today);
                yesterday.setDate(yesterday.getDate() - 1);
                return yesterday;
              }
            }
          ]}
          style={{ width: 173 }}
          size="lg"
          defaultValue={props.value}         
          onChange={(date) => defaultOnChange(date)}
          onBlur={(e) => props.onBlur(e)}
          onFocus={(e) => defaultOnFocus(e)}
          id={props.id}
          oneTap={props.disableConfirm}
		  cleanable={true}
          onClean={props.onClean}
        />
      </div>
      <span
        className="date-time-picker__error"
        style={props.hasError ? {} : { display: "none" }}
      >
        {props.errorMessage}
      </span>
    </div>
  );
};

export default DateInput;
